export default __webpack_public_path__ + "static/media/logo-bg.33674127.png";